import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VulcanIconComponent } from '@eagle-i/vulcan-component-library';
import BaseLayer from 'ol/layer/Base';
import { Observable } from 'rxjs';
import { YearSelectorComponent } from '../../core/global-filters/year-selector/year-selector.component';
import { AppService } from '../../services/app.service';
import { MapService } from '../../services/map.service';
import { MapGroup } from '../../shared/classes/map-group';
import { MapControlsComponent } from '../../shared/components/map-controls/map-controls.component';
import { MapLayerGroupComponent } from '../../shared/components/map-layer-group/map-layer-group.component';
import { MapComponent } from '../../shared/components/map/map.component';
import { SidebarGroupComponent } from '../../shared/components/sidebar-group/sidebar-group.component';

@Component({
  selector: 'tgrid-map-landing',
  imports: [
    MapComponent,
    MatExpansionModule,
    MatSidenavModule,
    MapLayerGroupComponent,
    MatExpansionModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MapControlsComponent,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    CdkDropList,
    CdkDrag,
    VulcanIconComponent,
    SidebarGroupComponent,
    YearSelectorComponent,
  ],
  templateUrl: './map-landing.component.html',
  standalone: true,
  styleUrl: './map-landing.component.scss',
})
export class MapLandingComponent {
  private mapService = inject(MapService);
  private appService = inject(AppService);

  public isOpen: boolean = true;
  public mapLayerGroups: Observable<MapGroup[]> = this.mapService.getMapLayerGroups();

  public currentMapLayer = signal<BaseLayer[]>([]);


  clearActiveFilters() {
    this.mapService.clearActiveLayers.next();
  }




  protected handleDropEvent(event: CdkDragDrop<BaseLayer[], BaseLayer[]>) {
    moveItemInArray(this.currentMapLayer(), event.previousIndex, event.currentIndex);
    this.updateZIndex();
  }


  private updateZIndex() {
    const maxLength = this.currentMapLayer().length;
    this.currentMapLayer().forEach((layer, index) => {
      // We multiply by -1 because we want the top of the rendered list to have the highest z-index
      const zIndex = (maxLength + (index * -1)) + 100;
      layer.setZIndex(zIndex);
    });
  }


  /**
   * A callback method that listens
   * @param layer The layer that is being added or removed from the map
   * @param [addOrRemove] If true, the layer is being added, else it is being removed. Defaults to true
   * @protected
   */
  protected mapLayerChange(layer: BaseLayer, addOrRemove: boolean = true) {
    this.currentMapLayer.update(value => {
      if (addOrRemove) {
        value.unshift(layer);
      } else {
        const index = value.findIndex(layerOnMap => layerOnMap.get('name') === layer.get('name'));
        value.splice(index, 1);
      }
      return value;
    });

    this.updateZIndex();
  }

  protected handleYearChange(selectedYears: number[]) {
    this.appService.selectedYears.set(selectedYears);
  }
}
